import styled, { css } from 'styled-components';

export const UpgradeListing = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
`;

export const SectionHeader = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.xl};
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    overflow: hidden;
  `}
`;

export const SectionHeaderTitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['2xlarge']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.brand.snappyBlue[15]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }
  `}
`;

export const SectionHeaderDescription = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }    
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.xl};
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  `}
`;

export const ErrorLoadingList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  padding: 0;
  width: 100%;
`;

export const ErrorLoadingListText = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const ErrorLoadingListButton = styled.div`
  width: auto;
`;
